export const ACTION_LOG_TYPE = {
    SYSTEM_ACCESS: 1,
    ADMIN_ACTIONS: 2,
    USER_ACTIONS: 3
};
